/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */
import { Typography } from "@material-ui/core";
import FeaturedGridCard from "../../page-sections/singleproperty/sub-component/FeaturedGridCard";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  heading: {
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "2.125rem",
    lineHeight: "3.1875rem",
    margin: "0rem 0rem 1rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  double: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "noWrap",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-webkitOverflowScrolling": "touch",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "25rem",
    },
    [theme.breakpoints.only("xs")]: {
      height: "27rem",
    },
    /* XSSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      height: "28.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      height: "27rem",
    },
    [theme.breakpoints.only("md")]: {
      height: "31rem",
    },
    [theme.breakpoints.only("lg")]: {
      height: "28rem",
    },
    [theme.breakpoints.only("xl")]: {
      height: "28rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "30rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      height: "33rem",
    },
  },
  doubleDouble: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      width: "90%",
    },
    [theme.breakpoints.only("xs")]: {
      width: "90%",
    },
    /* XSSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      width: "75%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "48%",
    },
    [theme.breakpoints.only("md")]: {
      width: "45.5%",
    },
    [theme.breakpoints.only("lg")]: {
      width: "33.33333%",
    },
    [theme.breakpoints.only("xl")]: {
      width: "30%",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "24%",
    },
    flex: "0 0 auto",
  },
}));

const FeaturedProperties = (props) => {
  const classes = useStyles();
  const { featuredProperties } = props;
  return (
    <React.Fragment>
      <Typography variant="h1" component="span" className={classes.heading}>
        Featured Properties
      </Typography>
      <div className={classes.double}>
        {featuredProperties.map((property, key) => {
          return (
            <div
              key={key}
              className={classes.doubleDouble}
              style={{ marginLeft: key == 0 ? undefined : "0.5rem" }}
            >
              <FeaturedGridCard
                imageSrc={property.thumbnail_image.url}
                slug={property.slug}
                title={property.title}
                location={property.location.title}
                builder={property.builder.name}
                price={property.price}
                area={property.area}
                areaType="carpet_area"
                areaUnit="ft"
                config={property.config}
                chips={property.tags}
                pdfHref={property.pdf}
                bhk={property.bhk}
              />
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default FeaturedProperties;
